// Material Symbols (Rounded) — the Material 3 icon set, matching WapMeet.
// The font is self-hosted as a SUBSET (see src/fonts/material-symbols-rounded-subset.woff2
// and its @font-face in styles.css) covering exactly the ligature names listed
// in ICON_NAMES below — ~70KB instead of the 5.35MB full variable font that the
// npm `material-symbols` package ships. A name outside the subset renders as
// literal English text, so add it to scripts/generate-icon-subset.sh and
// regenerate before using it.
//
// `fill` toggles the filled variant used for active nav destinations, per M3.
type IconProps = {
  name: string;
  size?: number;
  fill?: boolean;
  weight?: number;
  className?: string;
};

export function Icon({ name, size = 24, fill = false, weight = 400, className = '' }: IconProps): JSX.Element {
  const opsz = Math.max(20, Math.min(48, size));
  return (
    <span
      aria-hidden
      translate="no"
      className={`material-symbols-rounded ${className}`}
      style={{
        fontSize: `${size}px`,
        lineHeight: 1,
        fontVariationSettings: `'FILL' ${fill ? 1 : 0}, 'wght' ${weight}, 'GRAD' 0, 'opsz' ${opsz}`,
      }}
    >
      {name}
    </span>
  );
}
